export default __webpack_public_path__ + "static/media/bongo.daba5c18.svg";